import IngredientDetailModal from './IngredientDetailModal'

export default IngredientDetailModal
